import { render, staticRenderFns } from "./SuccessAcademy.vue?vue&type=template&id=703f3818&scoped=true&"
import script from "./SuccessAcademy.vue?vue&type=script&lang=js&"
export * from "./SuccessAcademy.vue?vue&type=script&lang=js&"
import style0 from "./SuccessAcademy.vue?vue&type=style&index=0&id=703f3818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f3818",
  null
  
)

export default component.exports